import { ChangeDetectionStrategy, Component, input } from '@angular/core';
import { UserTradeUrlComponent } from '../user-trade-url/user-trade-url.component';

@Component({
  selector: 'app-user-trade-url-modal',
  imports: [UserTradeUrlComponent],
  templateUrl: './user-trade-url-modal.component.html',
  styleUrl: './user-trade-url-modal.component.scss',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  host: {
    class: 'modal-container flex flex-col',
  },
})
export class UserTradeUrlModalComponent {
  onMountFocusTradeURL = input<boolean>(false);
}
